import React from "react";

import prizeGreenIcon from "../../../assets/svg/prize-green.svg";
import stopIcon from "../../../assets/svg/stop.svg";

type ClosedOrderStatusProps = {
  profit?: number;
};

const getProfitColor = (profit: number) => {
  if (profit > 0) return "profit-positive";
  if (profit < 0) return "profit-negative";
  return "profit-neutral";
};

const StatusLabel: React.FC<{ profit: number }> = ({ profit }) => {
  if (profit === 0) return <>⚪ Closed</>;

  const isWin = profit > 0;
  return (
    <>
      <img
        className="status__icon"
        src={isWin ? prizeGreenIcon : stopIcon}
        alt={isWin ? "Win logo" : "Loss logo"}
      />
      <span className="status__text">{isWin ? "Profit" : "Loss"}</span>
    </>
  );
};

export const ClosedOrderStatus: React.FC<ClosedOrderStatusProps> = ({
  profit,
}) => {
  const profitColor = getProfitColor(profit ?? 0);

  return (
    <div className={`order__status ${profitColor}`}>
      <div className="status">
        <StatusLabel profit={profit ?? 0} />
      </div>
      <div className={`order__profit ${profitColor}`}>
        <span className="value">{profit ?? "---"}</span>
        <span className="currency">$</span>
      </div>
    </div>
  );
};
